// Home (/) — the playbook launchpad.
//
// One job: visitor lands → sees a search bar with rotating multi-LLM
// playbooks below it → picks one → an inline chat walks them through it
// step-by-step, teaching them which model to use at each step. No
// sign-in required, no navigation off the home page.
//
// Everything else (directory, comparisons, mastery, hub) lives on its own
// route and is reachable through the navbar/footer — this page stays
// laser-focused on the first 30 seconds.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";
import PlaybookSearchHero from "@/components/home/PlaybookSearchHero";
import ContinueStrip from "@/components/home/ContinueStrip";
import PillarGrid from "@/components/home/PillarGrid";
import HackathonBanner from "@/components/hackathon/HackathonBanner";
import BeginnerStartBanner from "@/components/beginner/BeginnerStartBanner";
import FirstTimeHero from "@/components/beginner/FirstTimeHero";
import { useAuth } from "@/hooks/useAuth";
import { useBeginnerMode } from "@/hooks/useBeginnerMode";
import { trackFunnel } from "@/lib/funnelTracker";

const Index = () => {
  const location = useLocation();
  const { user, loading } = useAuth();
  const { welcomeSeen, completed } = useBeginnerMode();

  useEffect(() => {
    trackFunnel("landing_view", { route: location.pathname });
  }, [location.pathname]);

  // True first-timers — signed out, never opened Beginner Mode, no
  // skills completed — get the radically simplified one-button hero.
  // Anyone who has touched the site (returning visitor, signed-in
  // user, or someone with progress) keeps the full landing page.
  const showFirstTimeHero =
    !loading && !user && !welcomeSeen && completed.length === 0;

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {showFirstTimeHero ? (
        <>
          {/* No top banner / no nav clutter for true first-timers —
              the live pot lives inside the hero card itself. */}
          <Navbar />
          <main className="flex-1">
            <FirstTimeHero />
          </main>
        </>
      ) : (
        <>
          <HackathonBanner />
          <Navbar />
          <BeginnerStartBanner />
          <main className="flex-1">
            <PlaybookSearchHero />
            <ContinueStrip />
            <PillarGrid />
          </main>
        </>
      )}
      <SiteFooter />
    </div>
  );
};

export default Index;
